export default "__VITE_PUBLIC_ASSET__82e8cdd0__"